import { render, staticRenderFns } from "./RecipeCompare.vue?vue&type=template&id=1a1f28cd&scoped=true&"
import script from "./RecipeCompare.vue?vue&type=script&lang=ts&"
export * from "./RecipeCompare.vue?vue&type=script&lang=ts&"
import style0 from "./RecipeCompare.vue?vue&type=style&index=0&id=1a1f28cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1f28cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAutocomplete,VBtn,VIcon,VSimpleTable})
